class NewsletterPopup extends HTMLElement {
    constructor() {
        super();

        this.overlay = this.querySelector(".newsletter-popup-overlay");
        this.closeButton = this.querySelector(".newsletter-popup__close-btn");
        this.modal = this.querySelector(".newsletter-popup__wrapper");
        this.delay = this.dataset.delay;
        this.frequency = this.dataset.frequency;

        const timeline = gsap.timeline({
            paused: true,
            reversed: true
        });

        this.tl = timeline;

        // Check if the "newsletter-popup" cookie is set
        const cookieExists = document.cookie.split(';').some(cookie => cookie.trim().startsWith('newsletter-popup='));

        this.animate();
        if (!cookieExists && !Shopify.designMode) {
            this.openModal();
        }

        this.eventListeners();
    }

    animate() {
        this.tl
            .set(this, {
                display: "flex"
            }, 0)
            .fromTo(this.overlay, {
                autoAlpha: 0,
            }, {
                autoAlpha: 1,
            }, 0.15)
            .fromTo(this.modal, {
                ease: "Power4.inOut",
                duration: 1.2,
                autoAlpha: 0,
                y: "100%"
            }, {
                y: 0,
                autoAlpha: 1
            }, 0.4)
    }

    openModal(delay = this.delay) {
        setTimeout(() => {
            this.classList.add('is-open');
            this.tl.play();
            this.tl.then(() => {
                const focusElement = this.querySelector('input[type="email"]') || this.closeButton;
                trapFocus(this.modal, focusElement);
            })
            document.body.classList.add('newsletter-popup-open', 'overflow-hidden');
        }, delay);
    }

    closeModal() {
        this.classList.remove('is-open');
        this.tl.reverse();
        removeTrapFocus(this.activeElement);
        document.body.classList.remove('newsletter-popup-open', 'overflow-hidden');
        this.createCookie();
    }

    createCookie() {
        this.date = new Date();
        this.days = this.frequency || 1; // Default to 1 day if no value is provided
        this.date.setTime(this.date.getTime() + (this.days * 24 * 60 * 60 * 1000)); // Convert days to milliseconds
        document.cookie = "newsletter-popup=true; expires=" + this.date.toUTCString() + "; path=/";
    }

    eventListeners() {
        this.overlay.addEventListener('click', this.closeModal.bind(this))
        this.closeButton.addEventListener('click', this.closeModal.bind(this))
    }
}
customElements.define('newsletter-popup', NewsletterPopup);
